const pick = function (obj) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }
  return keys.flat().filter(key => Object.prototype.hasOwnProperty.call(obj, key)).reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
};
const omit = function (obj) {
  for (var _len2 = arguments.length, keysToOmit = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keysToOmit[_key2 - 1] = arguments[_key2];
  }
  const keysToOmitSet = new Set(keysToOmit.flat());
  return Object.getOwnPropertyNames(obj).filter(key => !keysToOmitSet.has(key)).reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
};
module.exports = {
  pick,
  omit
};